import { MaintenanceWindowsDeleteDialogWebComponent } from './component/MaintenanceWindowsDeleteDialogWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOWS_DELETE_DIALOG } from '../../webcomponents.constants';

export { MaintenanceWindowsDeleteDialogWebComponent };

window.customElements.define(
  WEB_COMPONENT_MAINTENANCE_WINDOWS_DELETE_DIALOG,
  MaintenanceWindowsDeleteDialogWebComponent
);
